import { ReportScoringService } from './report-scoring.service';

export default angular
  .module('sfMobile.services.reportScoring', ['sfMobile.services.forms'])
  .service('reportScoringService', ReportScoringService).name;
